// Options Object
// menuRoleSelector: Overall parent element that takes the aria role attribute, and receives focus to activate the menu when toggleControl isn't set.
// menuParentSelector: Selector for parent element that contains menu items.
// menuItemSelector: Selector for menu items.
// menuItemParentSelector: Selector for menu item parent
// menuItemParentCrawl: Whether to use .parents() or .parent() when looking for menuItemParentSelector. Can be useful if your menu structure isn't a repeated pattern.
// menuVisibilityClass: Class for when menu is visible
// toggleControlClass: Class to assign to the toggle control when the menu is active
// menuFocusedClass: Class to assign when a menu receives focus
// menuExpandedClass: Class to assign when a menu is expanded
// idPrefix: Prefix for unique ids that are generated for menu items
// onItemExpanded: Callback for when a sub-menu is expanded
// onItemCollapsed: Callback for when a sub-menu is collapsed
// onItemFocused: Callback for when an item is focused
// onMenuOpened: Callback for when the overall menu is activated
// onMenuClosed: Callback for when the overall menu is closed
// orientation: Orientation used matches depth of current menu

// Example:
// var mainMenuElement = $('#main_menu');
// mainMenuElement.accessibleMenu(null, {
// 	menuItemSelector: 'a',
// 	orientation: window.is_mobile ? 'vertical' : ['horizontal', 'vertical'],
// 	onItemExpanded: function(item, parent) {
// 		console.log('expanded');
// 	},
// 	onItemCollapsed: function(item, parent) {
// 		console.log('collapsed');
// 	}
// });

jQuery.fn.accessibleMenu = function(toggleControl, opts) {
	var uid = 0;
	var menuWrapper = this;
	var state = {
		currentFocusedItem: null
	};

	var defaults = {
		menuRoleSelector: 'nav',
		menuParentSelector: 'ul',
		menuItemSelector: 'a',
		menuItemParentSelector: 'li',
		menuItemParentCrawl: false,
		menuVisibilityClass: 'visible',
		toggleControlClass: 'active',
		menuFocusedClass: 'focused',
		menuExpandedClass: 'expanded',
		idPrefix: 'menu-id-',
		onItemExpanded: function(focusedItem, expandedMenu) {},
		onItemCollapsed: function(itemParent) {},
		onItemFocused: function(item) {},
		onMenuOpened: function(menuWrapper) {},
		onMenuClosed: function(menuWrapper) {},
		orientation: ['horizontal', 'vertical']
	}

	window.uid = typeof window.uid == 'undefined' ? 1 : window.uid+1

	opts = $.extend(defaults, opts);

	var menu = menuWrapper.find(opts.menuRoleSelector);

	var onKey = function(element, key, func) {
		var keys = {tab: 9, enter: 13, down: 40, up: 38, left: 37, right: 39, escape: 27};
		var bindings = element.data('bindings') || {};
		bindings[keys[key]] = func;
		element.data('bindings', bindings);

		if ($(element).data('listener')) return;

		element.data('listener', true);

		element.keydown(function (e) {
			if (bindings[e.which]) {
				e.stopImmediatePropagation(0);
				return bindings[e.which]();
			}
		});
	}

	var getOrientation = function() {
		var depth = state.currentFocusedItem ? state.currentFocusedItem.depth : 0;

		if (!opts.orientation[depth])
			return lodash.takeRight(opts.orientation, 1);

		return opts.orientation[depth];
	}

	if (toggleControl) {
		toggleControl.click(function() {
			api.toggleMenu();
			return false;
		});

		onKey(toggleControl, 'enter', function(e) {
			api.toggleMenu();
			return false;
		});

		onKey(toggleControl, 'down', function() {
			api.showMenu();
			api.focusItem(opts.semanticTree[0]);
			return false;
		});
	} else {
		onKey(menuWrapper, 'enter', function(e) {
			api.showMenu();
			api.focusItem(opts.semanticTree[0]);
			return false;
		});

		onKey(menuWrapper, 'down', function() {
			api.showMenu();
			api.focusItem(opts.semanticTree[0]);
			return false;
		});
	}

	onKey(menu, 'tab', function() {
		api.hideMenu();
		return false;
	});

	onKey(menu, 'left', function() {
		if (getOrientation() == 'vertical') {
			api.ascend();
		} else {
			api.navigatePrevious();
		}
		return false;
	});

	onKey(menu, 'right', function() {
		if (getOrientation() == 'vertical') {
			api.descend();
		} else {
			api.navigateNext();
		}
		return false;
	});

	onKey(menu, 'up', function() {
		if (getOrientation() == 'horizontal') {
			api.ascend();
		} else {
			api.navigatePrevious();
		}
		return false;
	});

	onKey(menu, 'down', function() {
		if (getOrientation() == 'horizontal') {
			api.descend();
		} else {
			api.navigateNext();
		}
		return false;
	});

	onKey(menu, 'enter', function() {
		if (api.descend())
			return false;
	});

	onKey(menu, 'escape', function() {
		if (state.currentFocusedItem.parent.controller) {
			api.ascend();
		} else {
			api.hideMenu();
		}
		return false;
	});

	// Select menu sibling that starts with the letter/number pressed.
	menu.keydown(function(e) {
		var letter = String.fromCharCode(e.which);
		var pattern = /[\w\d]/;
		if (!letter || !pattern.test(letter)) return true;

		var current = null;
		var postMatches = [];
		var preMatches = [];
		$.each(getCurrentSiblings(), function(i) {
			if (this == state.currentFocusedItem)
				return current = i;

			if ($(this.element).text().toLowerCase().startsWith(letter.toLowerCase())) {
				if (current) {
					postMatches.push(this);
				} else {
					preMatches.push(this);
				}
			}
		});

		matches = postMatches.concat(preMatches);
		api.focusItem(matches[0]);
		if (matches.length)
			return false;
	});

	var getCurrentSiblings = function() {
		if (!state.currentFocusedItem) return [];

		return state.currentFocusedItem.parent.children;
	}

	var getItemDepth = function(item) {
		return $(item).parents(defaults.menuParentSelector).length;
	}

	var getUniqueId = function(slug) {
		uid += 1;
		return opts.idPrefix + slug + '-' + window.uid + '-' + uid;
	}

	// Clear current state
	var resetStateDecorations = function() {
		menu.find(opts.menuItemSelector).each(function() {
			$(this).attr('aria-expanded', false);
		});
		menu.find('.' + opts.menuExpandedClass).removeClass(opts.menuExpandedClass);
		menu.find('.' + opts.menuFocusedClass).removeClass(opts.menuFocusedClass);
	}

	var expandParents = function() {
		resetStateDecorations();
		// Set expanded states.
		$(state.currentFocusedItem.parent.element).parent().addClass(opts.menuExpandedClass);
		$(state.currentFocusedItem.parent.element).addClass(opts.menuExpandedClass);

		opts.onItemExpanded(state.currentFocusedItem, state.currentFocusedItem.parent);

		if (state.currentFocusedItem.parent.controller) {
			$(state.currentFocusedItem.parent.controller.element).attr('aria-expanded', true).addClass(opts.menuExpandedClass);
		}
	}

	var buildSemanticTree = function() {
		var tree = [];
		var menus = menu.find(opts.menuParentSelector);
		menus.each(function(i) {
			var depth = getItemDepth(this);
			var semanticEntry = {depth: depth, children: [], element: this};

			$(this).data('tree', semanticEntry);

			tree.push(semanticEntry);
		});

		menu.find(opts.menuItemSelector).each(function() {
			var controls = null
			if (opts.menuItemParentCrawl) {
				controls = $(this).parents(opts.menuItemParentSelector).eq(0).find(opts.menuParentSelector).eq(0).data('tree');
			} else {
				controls = $(this).parent(opts.menuItemParentSelector).eq(0).find(opts.menuParentSelector).eq(0).data('tree');
			}
			var closestParent = $(this).parents(opts.menuParentSelector).eq(0).data('tree');
			var semanticEntry = {index: closestParent.children.length, depth: closestParent.depth, parent: closestParent, element: this, controls: controls ? controls : null};
			if (controls)
				controls.controller = semanticEntry;
			closestParent.children.push(semanticEntry);
			$(this).data('tree', semanticEntry);
		});

		opts.semanticTree = tree;
	}

	// Add Aria stuff
	var decorateMenu = function() {
		// menuWrapper.attr('role', 'menubar');
		var id = 0;

		console.log(opts.semanticTree);

		$.each(opts.semanticTree, function() {
			if (!$(this.element).attr('id'))
				$(this.element).attr('id', getUniqueId('menu'));

			if(this.depth = 0)
				$(this.element).attr('role', 'menubar');

			if(this.depth = 1)
				if($(this.element).hasClass('sub-menu'))
					$(this.element).attr('role', 'menu');
				else
					$(this.element).attr('role', 'menubar');

			var children = this.children;
			var owns = [];
			$.each(children, function() {
				var newID = getUniqueId('item');
				owns.push(newID);
				$(this.element).attr('id', newID);
				$(this.element).attr('aria-posinset', this.index+1);
				$(this.element).attr('role', 'menuitem');
				$(this.element).attr('aria-setsize', children.length);
				$(this.element).parent().attr('role', 'none');
				if (this.controls) {
					$(this.element).attr('aria-haspopup', true);
					$(this.element).attr('aria-expanded', false);
				}
			});

			$(this.element).attr('aria-owns', owns.join(' '));
		});
	}

	// Make menu items not tab stops.
	var tabStopFix = function() {
		var items = menu.find(defaults.menuItemSelector).attr('tabindex', -1);
		if (!toggleControl)
			menuWrapper.attr('tabindex', 0);
	}

	var api = menu.api = {
		focusItem: function(item) {
			if (!item) return;

			if (item.children) {
				item = item.children[0];
			}

			if (state.currentFocusedItem && item.parent != state.currentFocusedItem.parent)
				opts.onItemCollapsed(state.currentFocusedItem.parent);

			state.currentFocusedItem = item;
			tabStopFix();
			expandParents();
			$(item.element).attr('tabindex', 0).focus();
			$(item.element).addClass(opts.menuFocusedClass);
			opts.onItemFocused(item.element);
		},

		ascend: function() {
			if (!state.currentFocusedItem || !state.currentFocusedItem.parent.controller) return;

			var focusedItem = state.currentFocusedItem.parent.controller
			api.focusItem(focusedItem);
		},

		descend: function() {
			if (!state.currentFocusedItem) return;

			var child = state.currentFocusedItem.controls;
			if (child && child.children) {
				api.focusItem(child.children[0]);
				return true;
			}
			return false;
		},

		navigate: function(dir) {
			if (!state.currentFocusedItem) return;

			var index = state.currentFocusedItem.index;
			var focusedItem = getCurrentSiblings()[index + dir];
			if (focusedItem) {
				api.focusItem(focusedItem);
			} else {
				var siblings = getCurrentSiblings();
				api.focusItem(siblings[dir == -1 ? siblings.length-1 : 0]);
			}
		},

		navigateNext: function() {
			api.navigate(1);
		},

		navigatePrevious: function() {
			api.navigate(-1);
		},

		toggleMenu: function() {
			if (menu.hasClass(opts.menuVisibilityClass)) {
				api.hideMenu();
			} else {
				api.showMenu();
			}
		},

		showMenu: function() {
			menu.addClass(opts.menuVisibilityClass);
			if (toggleControl)
				toggleControl.addClass(opts.toggleControlClass)
			api.focusItem(opts.semanticTree[0]);
			opts.onMenuOpened(menuWrapper);
		},

		hideMenu: function(doFocus) {
			doFocus = (typeof doFocus !== 'undefined') ?  doFocus : true;

			tabStopFix();
			resetStateDecorations();
			menu.removeClass(opts.menuVisibilityClass);
			state.currentFocusedItem = null;
			if (doFocus) {
				if (toggleControl) {
					toggleControl.removeClass(opts.toggleControlClass)
					toggleControl.focus();
				} else {
					menuWrapper.focus();
				}
			}
			opts.onMenuClosed(menuWrapper);
		}
	}

	tabStopFix();
	if (!opts.semanticTree)
		buildSemanticTree();
	decorateMenu();

	this.api = api;
	return this;
}
